export default "/static/dashboard/build/app/img/v2/821d2bf38eb77ffe777793751c077a32.png";